/* This code is used for inserting and removing export indicator bar between richEdit toolbar and document view.
 *  It is impossible to make it only with richEdit API, because API does not have required ability.
 *  RichEdit API have only Ribbon menu modifications, that does not allow to make extra toolbar for indicator.
 *
 *  DocumentExportLoader.scss styles must be imported to page with this loader.
 * */

import Success from 'assets/icons/success.svg';
import Loader from 'assets/icons/loader.svg';
import Cross from 'assets/icons/cross.svg';
import { RichEdit } from 'components/devexpress/RichEdit/dx-richedit.ts';
import i18next from 'i18next';

const loaderId = 'export-loader';
const loaderButtonId = 'export-loader-button';
const originalHeightAttribute = 'original-height';

export const switchDocumentExportLoader = (
  richEdit: RichEdit,
  enable: boolean,
) => {
  if (enable) {
    if (exportLoaderElement()) {
      return;
    }
    addLoader(loadingState());
  } else {
    removeLoaderLater();
  }
  richEdit.adjust();
};

const addLoader = (state: string) => {
  // Insert loader
  document
    .querySelectorAll('.dx-tabpanel[role="tabpanel"]')[0]
    ?.appendChild(createElement(state));

  // richEdit.adjust() only shrinks document view, but it must be stretched after loader removing.
  // This function saves height for later set.
  saveOriginalDocumentViewHeight();

  exportLoaderButtonElement()?.addEventListener('click', removeLoader);
};

const removeLoader = () => {
  exportLoaderElement()?.remove();
  setOriginalDocumentViewHeight();
};

const removeLoaderLater = () => {
  removeLoader();
  addLoader(loadedState());
  setTimeout(() => {
    removeLoader();
  }, 2000);
};

// Styles located at: src/components/devexpress/RichEdit/RichEditComponent.override.scss
const loadingState = () => `<div id=${loaderId}>
  <img src=${Loader} class="rotating" height="20" width="20" alt=""/>
  <p>${i18next.t('Page.DocumentEditor.Export.Loader.InProgress')}</p>
  </div>`;

const loadedState = () => `<div id=${loaderId}>
  <img src=${Success} height="20" width="20" alt=""/>
  <p>${i18next.t('Page.DocumentEditor.Export.Loader.Finished')}</p>
  <button id=${loaderButtonId}>
    <img src=${Cross} height="20" width="20" alt=""/>
  </button>
  </div>`;

const saveOriginalDocumentViewHeight = () => {
  richEditDocumentElement()?.setAttribute(
    originalHeightAttribute,
    richEditDocumentElement()!.style['height'],
  );
};

const setOriginalDocumentViewHeight = () => {
  const richEditDocument = richEditDocumentElement();
  if (richEditDocument) {
    richEditDocument.style['height'] = richEditDocument.getAttribute(
      originalHeightAttribute,
    )!;
  }
};

const richEditDocumentElement = () => document.getElementById('_View');

const exportLoaderElement = () => document.getElementById(loaderId);

const exportLoaderButtonElement = () => document.getElementById(loaderButtonId);

function createElement(htmlStr: string) {
  let frag = document.createDocumentFragment();
  let temp = document.createElement('div');
  temp.innerHTML = htmlStr;
  while (temp.firstChild) {
    frag.appendChild(temp.firstChild);
  }
  return frag;
}
